import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

import no from "vuetify/src/locale/no";

export default new Vuetify({
  lang: {
    locales: { no },
    current: "no",
  },
  icons: {
    iconfont: "mdi" || "fa",
  },
  breakpoint: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 700,
      sm: 1200,
      md: 1600,
      lg: 1920,
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        yellow: "#FDB913",
        primary: "#3C4883",
        secondary: "#FDB913",
        primaryText: "#626262",
        secondaryText: "#211802",
        darkText: "#262626",
        lightGrey: "#dcdcdc",
        bodyBG: "#F6F6F6",
        navbar: "#FDB913",
        collapsableHeaderBG: "#EEEEEE",
        collapsableHeaderColor: "#3C4883",
        cardSurface: "#FFFFFF",
        cardBtnBadge: "#EEEEEE",
        // cardOutline: "",
        scrollbarBG: "#D5D5D5",
        scrollbarThumb: "#919191",
        mt: "#a02361",
        backgroundShadow: "#d8dae0",
        input: "#EEEEEE",
        inputText: "#000000",
        date: "#3C4883",
        listHighlight: "#f7f7f7",
        album: "3C4883",
        iconOnPrimary: "#FFFFFF",
        cardSurfaceDark: "#e7e7e7",
      },
      dark: {
        yellow: "#FDB913",
        primary: "#FDB913",
        secondary: "#3C4883",
        primaryText: "#FFFFFF",
        secondaryText: "#FDB913",
        darkText: "#262626",
        lightGrey: "#b4b4b4",
        bodyBG: "#262831",
        navbar: "#383940",
        collapsableHeaderBG: "#383940",
        collapsableHeaderColor: "#FFFFFF",
        cardSurface: "#383940",
        cardBtnBadge: "#676871",
        cardOutline: "#676871",
        scrollbarBG: "#383940",
        scrollbarThumb: "#676871",
        mt: "#a02361",
        backgroundShadow: "#29292a",
        input: "#48494f",
        inputText: "#ffffff",
        date: "#1E1E1E",
        listHighlight: "#43444a",
        album: "3C4883",
        iconOnPrimary: "#000000",
        cardSurfaceDark: "#48494f",
      },
    },
  },
});
